import React from 'react';
import { FastForward } from 'lucide-react';
import { Track } from '../types';
import { tg } from '../services/telegram';
import { PlayWedgeIcon, PauseBarsIcon, CassetteReelIcon } from './icons/HardwareIcons';

interface MiniPlayerBarProps {
  track: Track | null;
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  onTogglePlay: () => void;
  onNext: () => void;
  onOpenPlayer: () => void;
}

export const MiniPlayerBar: React.FC<MiniPlayerBarProps> = ({
  track,
  isPlaying,
  currentTime,
  duration,
  onTogglePlay,
  onNext,
  onOpenPlayer,
}) => {
  if (!track) return null;

  const progressPercent = duration > 0 ? (currentTime / duration) * 100 : 0;
  const shortRate = (track.sampleRate || '').replace('.0 kHz', '').replace(' kHz', '');
  const shortBit = (track.bitDepth || '').replace('-bit', '');

  return (
    <div className="mini-player-bar" onClick={onOpenPlayer}>
      {/* Top micro progress line */}
      <div className="mini-bar-progress-rail">
        <div
          className="mini-bar-progress-fill"
          style={{ width: `${Math.min(100, Math.max(0, progressPercent))}%` }}
        />
      </div>

      <div className="mini-bar-content">
        {/* Cover / Reel thumbnail */}
        <div className="mini-bar-cover-wrap">
          {track.coverUrl ? (
            <img src={track.coverUrl} alt={track.title} className="mini-bar-cover" />
          ) : (
            <div className="mini-bar-cover-fallback">
              <CassetteReelIcon size={14} color="var(--amber)" />
            </div>
          )}
          {isPlaying && (
            <div className="mini-bar-pulse-indicator" />
          )}
        </div>

        {/* Title and Artist */}
        <div className="mini-bar-info">
          <div className="mini-bar-title">{track.title}</div>
          <div className="mini-bar-sub">
            <span className="mini-bar-artist">{track.artist}</span>
            <span className="mini-bar-dot">•</span>
            <span className="mini-bar-spec">{shortBit}/{shortRate}</span>
          </div>
        </div>

        {/* Controls */}
        <div className="mini-bar-actions" onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            className="mini-bar-btn play-btn"
            onClick={() => {
              tg.haptic('medium');
              onTogglePlay();
            }}
            aria-label={isPlaying ? 'Пауза' : 'Воспроизведение'}
          >
            {isPlaying ? <PauseBarsIcon size={14} /> : <PlayWedgeIcon size={14} />}
          </button>

          <button
            type="button"
            className="mini-bar-btn"
            onClick={() => {
              tg.haptic('light');
              onNext();
            }}
            aria-label="Следующий трек"
          >
            <FastForward size={15} color="var(--champagne)" />
          </button>
        </div>
      </div>
    </div>
  );
};
